import { SECRIP_DETAIL, SECRIP_DETAIL_ERROR, SECRIP_DETAIL_HIDE_ERROR, SECRIP_DETAIL_START_LOADER, SECRIP_DETAIL_STOP_LOADER, } from "../../interfaces/common/ScripDetail";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const scripDetail = (state = initState, action) => {
    switch (action.type) {
        case SECRIP_DETAIL:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case SECRIP_DETAIL_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case SECRIP_DETAIL_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case SECRIP_DETAIL_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case SECRIP_DETAIL_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default scripDetail;
